import { render } from "./StoreAgreementTab.vue?vue&type=template&id=549d93ae&scoped=true"
import script from "./StoreAgreementTab.vue?vue&type=script&lang=js"
export * from "./StoreAgreementTab.vue?vue&type=script&lang=js"

import "./StoreAgreementTab.vue?vue&type=style&index=0&id=549d93ae&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-549d93ae"]])

export default __exports__